import React, { useState, useEffect } from 'react';
import './AdminValidationNotes.css';
import DashboardHeader from '../components/DashboardHeader';
import AdminNavigationBar from '../components/AdminNavigationBar';

function AdminValidationNotes() {
  const [notesSoumises, setNotesSoumises] = useState({});
  const [toutesLesNotes, setToutesLesNotes] = useState({});
  const [stats, setStats] = useState({
    total_soumis: 0,
    total_valides: 0,
    en_attente: 0,
    matieres_en_attente: 0
  });
  const [loading, setLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState('toutes');

  const loadValidationDashboard = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/notes/validation/dashboard');
      const data = await response.json();
      
      console.log('Validation dashboard response:', data);
      
      if (response.ok) {
        setNotesSoumises(data.notes_soumises || {});
        setToutesLesNotes(data.toutes_les_notes || {});
        setStats(data.stats || {
          total_soumis: 0,
          total_valides: 0,
          en_attente: 0,
          matieres_en_attente: 0
        });
      } else {
        console.error('Erreur API:', data);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadValidationDashboard();
  }, []);

  
  const validerNote = async (noteId) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/notes/${noteId}/valider`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        alert('Note validée avec succès');
        // Recharger immédiatement les données
        await loadValidationDashboard();
      } else {
        const error = await response.json();
        alert('Erreur: ' + (error.message || 'Erreur lors de la validation'));
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la validation');
    }
  };

  const validerGroupe = async (groupKey, notes) => {
    if (!window.confirm(`Voulez-vous valider toutes les ${notes.length} notes de ce groupe ?`)) {
      return;
    }

    try {
      let validees = 0;
      let erreurs = 0;

      for (const note of notes) {
        if (note.statut === 'soumis') {
          try {
            const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/notes/${note.id}/valider`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              }
            });

            if (response.ok) {
              validees++;
            } else {
              erreurs++;
            }
          } catch (error) {
            erreurs++;
          }
        }
      }

      if (validees > 0) {
        alert(`✅ ${validees} note(s) validée(s) avec succès${erreurs > 0 ? `\n⚠️ ${erreurs} erreur(s)` : ''}`);
        // Recharger immédiatement les données
        await loadValidationDashboard();
      } else {
        alert('Aucune note à valider dans ce groupe');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la validation du groupe');
    }
  };

  const filteredNotes = () => {
    // Si "toutes", afficher toutes les notes (soumises + validées)
    if (selectedFilter === 'toutes') return toutesLesNotes;
    
    // Si "soumis", afficher uniquement les notes soumises
    if (selectedFilter === 'soumis') return notesSoumises;
    
    // Pour les autres filtres (validé, brouillon), filtrer depuis toutes les notes
    const filtered = {};
    Object.entries(toutesLesNotes).forEach(([groupKey, notes]) => {
      const filteredNotesArray = notes.filter(note => note.statut === selectedFilter);
      if (filteredNotesArray.length > 0) {
        filtered[groupKey] = filteredNotesArray;
      }
    });
    
    return filtered;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  };

  const getStatutColor = (statut) => {
    switch (statut) {
      case 'soumis': return '#e74c3c';
      case 'valide': return '#27ae60';
      case 'brouillon': return '#f39c12';
      default: return '#95a5a6';
    }
  };

  const getStatutLabel = (statut) => {
    switch (statut) {
      case 'soumis': return 'Soumis';
      case 'valide': return 'Validé';
      case 'brouillon': return 'Brouillon';
      default: return 'Inconnu';
    }
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Validation des Notes" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="validation-content">
            {/* Statistiques */}
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">{stats.total_soumis}</div>
                <div className="stat-label">Total soumises</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.total_valides}</div>
                <div className="stat-label">Total validées</div>
              </div>
              <div className="stat-card pending">
                <div className="stat-number">{stats.en_attente}</div>
                <div className="stat-label">En attente</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.matieres_en_attente}</div>
                <div className="stat-label">Matières en attente</div>
              </div>
            </div>

            {/* Filtres */}
            <div className="filters-section">
              <div className="filter-group">
                <label>Filtrer par statut:</label>
                <select 
                  value={selectedFilter} 
                  onChange={(e) => setSelectedFilter(e.target.value)}
                >
                  <option value="toutes">Toutes les notes</option>
                  <option value="soumis">En attente de validation</option>
                  <option value="valide">Déjà validées</option>
                  <option value="brouillon">Brouillons</option>
                </select>
              </div>
            </div>

            {/* Liste des notes soumises */}
            {loading ? (
              <div className="loading">Chargement des notes...</div>
            ) : (
              <div className="notes-list">
                {Object.entries(filteredNotes()).map(([groupKey, notes]) => (
                  <div key={groupKey} className="notes-group">
                    <div className="group-header">
                      <h3>{groupKey}</h3>
                      <div className="group-actions">
                        <span className="notes-count">{notes.length} note(s)</span>
                        {notes.some(n => n.statut === 'soumis') && (
                          <button 
                            className="btn-valider-groupe"
                            onClick={() => validerGroupe(groupKey, notes)}
                            title="Valider toutes les notes de ce groupe"
                          >
                            ✅ Valider tout le groupe
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="notes-table-container">
                      <table className="notes-table">
                        <thead>
                          <tr>
                            <th>Élève</th>
                            <th>Matière</th>
                            <th>Type</th>
                            <th>Note</th>
                            <th>Statut</th>
                            <th>Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {notes.map(note => (
                            <tr key={note.id}>
                              <td className="student-name">
                                {note.etudiant?.prenom} {note.etudiant?.nom}
                              </td>
                              <td>{note.matiere}</td>
                              <td>
                                {note.type === 'devoir' && 'Devoir'}
                                {note.type === 'composition' && 'Composition'}
                                {note.type === 'examen' && 'Examen'}
                              </td>
                              <td className="note-value">
                                {note.note}/20
                              </td>
                              <td>
                                <span 
                                  className="statut-badge"
                                  style={{ backgroundColor: getStatutColor(note.statut) }}
                                >
                                  {getStatutLabel(note.statut)}
                                </span>
                              </td>
                              <td>{formatDate(note.created_at)}</td>
                              <td>
                                {note.statut === 'soumis' && (
                                  <button 
                                    className="btn-valider"
                                    onClick={() => validerNote(note.id)}
                                  >
                                    ✅ Valider
                                  </button>
                                )}
                                {note.statut === 'valide' && (
                                  <span className="valid-indicator">✓ Validée</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default AdminValidationNotes;
